import { Drawer, List } from 'antd';
import { ListContainer } from './styles';
import { useSelector } from 'react-redux';
import {
  fetchNotifications,
  selectNotificationCauses,
  selectNotificationIssues,
  selectNotificationRoutines,
} from '../../../slices/notifications';
import Tab from '../../../components/tab';
import ToBeReviewItem from '../../../components/toBeReviewItem';
import { useRef, useState } from 'react';
import SuggestionReviewDrawer from '../../../components/suggestionReviewDrawer';
import { useAppDispatch } from '../../../store';
import { Cause, Issue, QueryType, Routine } from '../../../types';
import ReviewRoutineDrawer from '../../../components/reviewRoutineDrawer';

const NotificationDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const dispatch = useAppDispatch();
  const [showReviewDrawer, setShowReviewDrawer] = useState(false);
  const currentItem = useRef<Issue | Cause | Routine>(null);
  const issues = useSelector(selectNotificationIssues);
  const causes = useSelector(selectNotificationCauses);
  const routines = useSelector(selectNotificationRoutines);

  const handleReviewDrawerClose = (isSubmitted?: boolean) => {
    setShowReviewDrawer(false);
    if (isSubmitted) {
      dispatch(fetchNotifications());
    }
  };

  const tabs = [
    {
      id: 1,
      title: 'Issues (To be Reviewed)',
      component: (
        <ListContainer>
          <List
            dataSource={issues}
            renderItem={(item) => (
              <ToBeReviewItem
                name={item.templateName}
                description={item.name}
                onClick={() => {
                  currentItem.current = item;
                  setShowReviewDrawer(true);
                }}
              />
            )}
          ></List>
        </ListContainer>
      ),
    },
    {
      id: 2,
      title: 'Causes (To be Reviewed)',
      component: (
        <ListContainer>
          <List
            dataSource={causes}
            renderItem={(item) => (
              <ToBeReviewItem
                name={item.templateName}
                description={item.name}
                onClick={() => {
                  currentItem.current = item;
                  setShowReviewDrawer(true);
                }}
              />
            )}
          ></List>
        </ListContainer>
      ),
    },
    {
      id: 3,
      title: 'Routine (To be Reviewed)',
      component: (
        <ListContainer>
          <List
            dataSource={routines}
            renderItem={(item) => (
              <ToBeReviewItem
                name={item.templateName}
                description={item.name}
                onClick={() => {
                  currentItem.current = item;
                  setShowReviewDrawer(true);
                }}
              />
            )}
          ></List>
        </ListContainer>
      ),
    },
  ];
  return (
    <>
      <Drawer
        open={open}
        closable
        width={600}
        title="Notifications"
        onClose={onClose}
      >
        <Tab tabs={tabs} />
      </Drawer>
      {currentItem.current &&
        ((currentItem?.current as Routine)?.routineID ? (
          <ReviewRoutineDrawer
            visible={showReviewDrawer}
            onClose={handleReviewDrawerClose}
            data={currentItem.current as Routine}
          />
        ) : (
          <SuggestionReviewDrawer
            visible={showReviewDrawer}
            onClose={handleReviewDrawerClose}
            queryType={
              'issueID' in (currentItem.current || {})
                ? QueryType.ISSUE
                : QueryType.CASUE
            }
            data={currentItem.current as Issue | Cause}
          />
        ))}
    </>
  );
};

export default NotificationDrawer;
